<template>
  <div class="upload-container">
    <el-button size="mini" icon="upload" type="success" @click="dialogVisible = true">上传图片</el-button>
    <el-dialog :visible.sync="dialogVisible">
      <el-upload
        action="http://resource.huaxuezoo.com/upload"
        list-type="picture-card"
        :on-remove="handleRemove"
        :fileList="fileList"
        :http-request="handlerImageUpload">
          <i class="el-icon-plus"></i>
        </el-upload>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handlerSubmit">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
/*
  @author: zhengxiaobei
  @date: 2018/06/xx
  @desc: 上传图片
  @params: {}
*/
import $ from 'jquery'
import lrz from 'lrz'

export default {
  name: 'w-upload',
  data () {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      list: {},
      fileList: []
    }
  },
  methods: {
    handleRemove (file) {
      const uid = file.uid
      delete this.list[uid]
    },
    handlerSubmit () {
      this.$emit('callback', Object.values(this.list))
      this.dialogVisible = false
      this.list = []
      this.fileList = []
    },
    handlerImageUpload (file) {
      lrz(file.file, {width: 500, quality: 0.9}).then(res => {
        let formData = new FormData()
        formData.append('file', res.file)
        $.ajax({
          type: 'POST',
          url: 'http://resource.huaxuezoo.com/upload',
          data: formData,
          timeout: 2000,
          contentType: false, // 必须false才会自动加上正确的Content-Type
          processData: false, // 必须false才会避开jQuery对 formdata 的默认处理, XMLHttpRequest会对o formdata 进行正确的处理
          success: (o) => {
            let data = JSON.parse(o)
            if (data.length > 0) {
              this.list[file.file.uid] = { url: data[0].url, uid: file.file.uid }
            }
          }
        })
      })
    }
  },
  created () {}
}
</script>

<style>
  .upload-container {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/base/upload.vue